import { createComponent } from '@carvana/merch-components';

export const FooterWrapper = createComponent('div', {
  className: 'flex flex-col items-center pt-xl lg:pt-7xl max-w-[1800px] mx-auto'
});

export const Footer = createComponent('footer', {
  className:
    'flex w-full max-w-[1400px] flex-col gap-y-xl rounded-tl-2xl rounded-tr-2xl bg-background-muted-strong px-2xl py-4xl text-text-inverse t-body-xs sm:px-3xl sm:py-7xl lg:p-7xl'
});

export const Pipe = createComponent('span', {
  className: 'h-[12px] w-px bg-text-inverse opacity-20'
});
